import useCompany from 'contexts/CompanyContext';

interface CompanyStatus {
    hasCompany: boolean;
    loading: boolean;
    error: string | null;
}

export default function useCompanyStatus(): CompanyStatus {
    const { hasCompanies, loading, error } = useCompany();

    return {
        hasCompany: hasCompanies,
        loading,
        error
    };
}